// Widget liste : 10 derniers dossiers créés.
import { useEffect, useState } from "react";
import { Loader2, ArrowRight } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function RecentDossiersWidget({ title }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("session_token");
    fetch(`${API}/api/metier/dossiers?limit=10&sort=-created_at`, {
      headers: token
        ? { Authorization: `Bearer ${token}`, "X-Tenant-ID": "tef" }
        : { "X-Tenant-ID": "tef" },
    })
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => setItems(Array.isArray(d) ? d : d?.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div
      className="rounded-xl p-5 h-full flex flex-col"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}
      data-testid="widget-recent-dossiers"
    >
      <p className="text-sm font-semibold mb-3" style={{ color: "var(--oh-text)" }}>
        {title || "Dossiers récents"}
      </p>
      {loading ? (
        <div className="flex items-center justify-center flex-1">
          <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} />
        </div>
      ) : items.length === 0 ? (
        <p className="text-sm" style={{ color: "var(--oh-text-muted)" }}>Aucun dossier.</p>
      ) : (
        <ul className="space-y-1 overflow-y-auto flex-1">
          {items.slice(0, 10).map((d, i) => (
            <li
              key={d._id || d.reference || i}
              className="flex items-center justify-between px-2 py-1.5 rounded text-sm"
              style={{ color: "var(--oh-text)" }}
            >
              <span className="truncate">
                {d.reference || "—"} <span style={{ color: "var(--oh-text-muted)" }}>· {d.client_nom || "—"}</span>
              </span>
              <ArrowRight className="w-3.5 h-3.5 shrink-0" style={{ color: "var(--oh-text-muted)" }} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
